import React from 'react';
import { Reveal } from './Reveal';
import { CtaButton } from './CtaButton';
import { useCountdown } from '../hooks/useCountdown';
export function FinalPush() {
  const {
    hours,
    minutes,
    seconds,
    expired
  } = useCountdown(12);
  return <section className="w-full bg-bark py-16 text-cream sm:py-24" aria-labelledby="impulso-title" data-id="element-90" data-mp="2dbjjq7e0wz3n">
      <div className="mx-auto max-w-3xl px-5 text-center sm:px-8" data-id="element-91" data-mp="28c70rxq9wc6c">
        <Reveal data-id="element-92" data-mp="23g9mry2hfhwq">
          <h2 id="impulso-title" className="font-display text-3xl font-semibold leading-tight tracking-tight sm:text-[2.6rem]" data-id="element-93" data-mp="23grm53kfyc8v">
            No es mañana. No es “cuando tenga tiempo”.
          </h2>
          <p className="mt-6 text-base leading-relaxed text-cream/80 sm:text-lg" data-id="element-94" data-mp="1uf1vw12apjco">
            Es hoy, en este momento, cuando tu cuerpo está pidiendo ayuda. Dentro de 7 días puedes
            verte en el espejo y reconocerte: tu cara definida, tu abdomen suave, tu mente clara, tu
            energía de vuelta.
          </p>
          <p className="mt-4 text-base leading-relaxed text-cream/70 sm:text-lg" data-id="element-95" data-mp="3jrnbmzf8a9x0">
            O puedes cerrar esta página y seguir lidiando con la inflamación, culpándote por una
            “falta de voluntad” que nunca fue tuya.
          </p>
          <p className="mt-6 font-display text-2xl leading-snug sm:text-3xl" data-id="element-96" data-mp="1jeuj51ndod1z">
            Con la Garantía de 60 Días, literalmente no tienes nada que perder. Solo una versión de
            ti que vale la pena conocer.
          </p>
        </Reveal>

        {!expired && <Reveal data-id="element-97" data-mp="2h1l3pmprujpq">
            <p className="mt-8 text-sm text-cream/60" data-id="element-98" data-mp="2h22xmcoyoluh">
              El precio sube a $99 cuando el reloj llegue a cero:{' '}
              <span className="font-semibold tabular-nums text-cream" data-id="element-99" data-mp="22bvr8vc8ata5">
                {hours}:{minutes}:{seconds}
              </span>
            </p>
          </Reveal>}

        <Reveal data-id="element-100" data-mp="2v0u7to0pdndc">
          <div className="mt-8 flex justify-center" data-id="element-101" data-mp="2v0b2d6s8org7">
            <CtaButton data-id="element-102" data-mp="2uzj942m475t3">SÍ, QUIERO ACCESO AHORA</CtaButton>
          </div>
          <p className="mt-4 text-xs text-cream/50" data-id="element-103" data-mp="2ztdlsm3aykio">
            Pago único de $15,90 USD · Acceso inmediato
          </p>
          <p className="mt-2 text-sm font-semibold text-cream/80" data-id="element-104" data-mp="39low539hjmsu">
            Garantía de reembolso de 60 días.
          </p>
        </Reveal>
      </div>
    </section>;
}